import React from 'react';

const PostAnAd = () => {
    return (
        <div>
            <p>This is Post An Ad</p>
        </div>
    );
};

export default PostAnAd;